module.exports = import("https://front-staging2.fitanalytics.com/integration_interface_esm.js");;